import { GET_PLAYERS_LOADING, GET_PLAYERS_SUCCESS, GET_PLAYERS_ERROR } from "../../../constant/actionTypes";

const playerAreaReducer = (state = {}, action) => {
    switch (action.type) {
        case GET_PLAYERS_LOADING: {
            let obj = {
                loading: true
            };
            return obj;
        }
        case GET_PLAYERS_SUCCESS: {
            let obj = {
                loading: false,
                data: action.response,
            };
            return obj;
        }
        case GET_PLAYERS_ERROR: {
            let obj = {
                loading: false,
                status: action.response
            };
            return obj;
        }
        default:
            return state;
    }
}

export default playerAreaReducer;